import { type FormikErrors } from 'formik'

const Y_OFFSET = 100 // px; account for top bar and input label

export const scrollToError = <FormSchema extends object>(
  errors: FormikErrors<FormSchema>
) => {
  const firstInvalidField = Object.keys(errors)?.[0]

  const fieldElement = document.getElementById(firstInvalidField)
  if (!fieldElement) return

  const invalidFieldTopPosition =
    fieldElement.getBoundingClientRect().top + window.pageYOffset - Y_OFFSET

  window.scrollTo({
    top: invalidFieldTopPosition,
    behavior: 'smooth',
  })
}
